import { render, staticRenderFns } from "./SimpleDonut.vue?vue&type=template&id=77ae9a62&"
import script from "./SimpleDonut.vue?vue&type=script&lang=js&"
export * from "./SimpleDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports